// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Metadata
 */
export interface Metadata {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof Metadata
   */
  annotations?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof Metadata
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof Metadata
   */
  name?: string;
}

/**
 * Check if a given object implements the Metadata interface.
 */
export function instanceOfMetadata(value: object): value is Metadata {
  return true;
}

export function MetadataFromJSON(json: any): Metadata {
  return MetadataFromJSONTyped(json, false);
}

export function MetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Metadata {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    labels: json['labels'] == null ? undefined : json['labels'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function MetadataToJSON(json: any): Metadata {
  return MetadataToJSONTyped(json, false);
}

export function MetadataToJSONTyped(
  value?: Metadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    labels: value['labels'],
    name: value['name'],
  };
}
